import hoistNonReactStatic from 'hoist-non-react-statics';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { reduce } from 'lodash';
import cookies from 'js-cookie';
import { ABServiceClient } from '@zocdoc/ab';
import { OPTIMIZELY_PROJECT_ID } from './constants';
import { getABParameters } from './selector';
import { sanitizeId } from './util';
import { isProduction } from '../../utils/environment';
import getDisplayName from '../../utils/displayName';

const client = new ABServiceClient({
    projectId: OPTIMIZELY_PROJECT_ID,
    fetch,
    basePath: process.env.AWS_API_HOST || '',
});

export default flags => WrappedComponent => {
    const wrappedDisplayName = `ABWrapper(${getDisplayName(WrappedComponent)})`;

    class ABWrapper extends React.Component {
        static propTypes = {
            assignments: PropTypes.object,
        };

        static displayName = wrappedDisplayName;

        componentDidMount() {
            if (document.readyState === 'complete') {
                this.handleRecording();
            } else {
                window.addEventListener('load', this.handleRecording);
            }
        }

        componentWillUnmount() {
            window.removeEventListener('load', this.handleRecording);
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    ab={this.props.assignments}
                />
            );
        }

        handleRecording = () => {
            if (Array.isArray(flags)) {
                flags.forEach(this.recordAssignment);
            } else {
                this.recordAssignment(flags);
            }
        }

        // Note that this method should only be called on the client so we are
        // triggering it in componentDidMount.
        recordAssignment = experiment => {
            // each experiment only needs to be recorded once
            // this only runs client-side, so passing hostname to isProduction isn't required
            if (experiment.recorded || !isProduction()) {
                return;
            }

            const sessionId = sanitizeId(cookies.get('bsid'));
            const trackingId = sanitizeId(cookies.get('firstTimeVisitor'));

            client.setAssignmentWithDefault({
                experiment: {
                    visitorIdType: 'sessionId', // default visitorIdType
                    ...experiment,
                    // TODO: make patientId available on the front-end and send it
                    //       when setting assignments
                    sessionId,
                    trackingId,
                },
                requestOriginUrl: window.location.href,
                userAgent: navigator.userAgent,
            });

            experiment.recorded = true;
        }
    }

    hoistNonReactStatic(ABWrapper, WrappedComponent);

    return connect(state => {
        const assignments = getABParameters(state);
        const flagsArr = [].concat(flags).filter(Boolean);

        return {
            assignments: {
                ...reduce(flagsArr, (props, flag) => {
                    props[flag.experimentId] = assignments[flag.experimentId]
                        || flag.defaultAssignment;
                    return props;
                }, {}),
            },
        };
    })(ABWrapper);
};
